import { Toaster as Sonner, type ToasterProps } from "sonner";
import { resolveTheme, useThemeStore } from "@/stores/theme";

// Ported from connect-v2; reads the MOS theme store instead of next-themes.
const Toaster = ({ ...props }: ToasterProps) => {
	const theme = useThemeStore((s) => s.theme);

	return (
		<Sonner
			theme={resolveTheme(theme)}
			className="toaster group"
			style={
				{
					"--normal-bg": "var(--popover)",
					"--normal-text": "var(--popover-foreground)",
					"--normal-border": "var(--border)",
				} as React.CSSProperties
			}
			{...props}
		/>
	);
};

export { Toaster };
